import script from "./SolicitacaoDefinicao.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitacaoDefinicao.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
